const PropTypes = require('prop-types');
const React = require('react');
const APIRequest = require('components/api_request.js');
const UserBadge = require('components/user_badge.jsx');

const CACHED_COUNTS_LOCAL_STORAGE_KEY = 'cachedCounts';
const BADGE_KEYS = [
  'active_offers',
  'unread_messages',
  'unpaid_orders',
  'seller_orders_refund_requested',
  'seller_orders_awaiting_shipment',
  'invoiced_statement_count',
  'billing_profile',
  'layaway_orders',
  'outstanding_feedback',
];

const PERSIST_BADGE_KEYS = [
  'unread_messages',
  'active_offers',
];

class UserBadges extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      counts: null,
      shown: false,
    };
  }

  componentDidMount() {
    this.loadBadgeCounts();
  }

  componentDidUpdate() {
    Reverb.HoverIntent.init();
  }

  getTotalCountAttr() {
    const count = this.state.counts && this.state.counts.total.count;
    return { 'data-notification-count': count || null };
  }

  findCountRecordByKey(key) {
    return this.state.counts[key];
  }

  shouldPersistBadge(key) {
    return PERSIST_BADGE_KEYS.includes(key);
  }

  makeDropdownItem(key) {
    return (
      <UserBadge
        key={key}
        rel={`${key}_badge`}
        countRecord={this.findCountRecordByKey(key)}
        persist={this.shouldPersistBadge(key)}
      />
    );
  }

  makeDropdownItems() {
    if (!this.state.counts) { return null; }

    const items = [];
    BADGE_KEYS.forEach((key) => {
      items.push(this.makeDropdownItem(key));
    });
    return items;
  }

  badgeCountsDidLoad(counts) {
    localStorage.setItem(CACHED_COUNTS_LOCAL_STORAGE_KEY, JSON.stringify(counts));
    this.setState({ counts, hasLoadedBadgeData: true });
  }

  loadBadgeCounts() {
    this.setState({
      counts: this.loadCachedCountsFromLocalStorage(),
    });
    const options = { headers: { 'Accept-Version': '3.0' } };

    APIRequest.get('/api/my/counts', {}, options)
      .then((counts) => this.badgeCountsDidLoad(counts));
  }

  loadCachedCountsFromLocalStorage() {
    const cachedCounts = localStorage.getItem(CACHED_COUNTS_LOCAL_STORAGE_KEY);
    if (cachedCounts) {
      try {
        return JSON.parse(cachedCounts);
      } catch (error) {
        console.error(error);
        localStorage.removeItem(CACHED_COUNTS_LOCAL_STORAGE_KEY);
      }
    }
    return null;
  }

  toggle() {
    this.setState({ shown: !this.state.shown });
    return false;
  }

  render() {
    const classes = 'site-header__nav__link site-header__nav__link--notification-icon';

    return (
      <div data-dropdown-trigger="true">
        <span
          className={classes}
          onClick={() => this.toggle()}
        >
          <div
            className="site-header__nav__link__icon"
            rel="total_notifications_badge"
            {...this.getTotalCountAttr()}
          />
          <div className="site-header__nav__link__label">
            {I18n.t('js.notificationBadges.notifications')}
          </div>
        </span>
        <div
          className="site-header__menu site-header__menu--notifications"
          data-dropdown="true"
          data-dropdown-active={this.state.shown}
        >
          <ul>
            {this.makeDropdownItems()}
          </ul>
        </div>
      </div>
    );
  }
}

UserBadges.propTypes = {
  isMobile: PropTypes.bool,
  hasLoadedBadgeData: PropTypes.bool,
};

UserBadges.defaultProps = {
  isMobile: false,
  hasLoadedBadgeData: false,
};

module.exports = UserBadges;



// WEBPACK FOOTER //
// ./javascripts/components/user_badges.jsx